import ApiService from './ApiService'
import moment from 'moment'

class TimetableService {

  getTimetableForDay = async (apiToken, date) => {
    var url = `/api/timetable/${moment(date).format('YYYY-MM-DD')}`
    var params = {}
    var timetable = null
    try {
      timetable = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return timetable
  }

  getTimetableForThisWeek = async (apiToken) => {
        var url = `/api/timetable/this-week`
        var params = {}
        var timetable = null
        try {
            timetable = await ApiService.get(apiToken, url, params)
        } catch (err) {
            console.error(err)
        }
        return timetable
    }

    getTimetableForStudent = async (apiToken, studentId, startDate, endDate) => {
        var url = `/api/timetable/student/${studentId}`
        var params = { startDate, endDate }
        var timetable = null
        try {
            timetable = await ApiService.get(apiToken, url, params)
        } catch (err) {
            console.error(err)
        }
        return timetable
    }

    getClassById = async (apiToken, classId) => {
        var url = `/api/timetable/class/${classId}`
        var params = {}
        var classData = null
        try {
            classData = await ApiService.get(apiToken, url, params)
        } catch (err) {
            console.error(err)
        }
        return classData
    }

}
export default new TimetableService()
